import React, { useEffect, useState } from 'react';

import { Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

import Spinners from 'components/Common/Spinner';
import { totalWeekShipmentLoading } from '../../store/actions';
//i18n
import { withTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

const OverviewShipment = props => {
	const DashboardProperties = createSelector(
		state => state.Dashboard,
		dashboard => ({
			isLoading: dashboard.totalweeksShipmentLoading,
			dataValue: dashboard.totalweekShipmentData
		})
	);
	const [arrivalVesselCount, setArrivalVesselCount] = useState(0);
	const [departureVesselCount, setDepartureVesselCount] = useState(0);

	const { isLoading, isError, dataValue } = useSelector(DashboardProperties);

	useEffect(() => {
		if (dataValue?.dashboardData?.arrivalVesselCount) {
			setArrivalVesselCount(dataValue?.dashboardData?.arrivalVesselCount);
		} else {
			setArrivalVesselCount(0);
		}

		if (dataValue?.dashboardData?.departureVesselCount) {
			setDepartureVesselCount(dataValue?.dashboardData?.departureVesselCount);
		} else {
			setDepartureVesselCount(0);
		}
	}, [dataValue]);

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(totalWeekShipmentLoading());
	}, [dispatch]);

	return (
		<React.Fragment>
			<Card className="overflow-hidden">
				<CardBody className="pt-0">
					{isLoading ? (
						<Row>
							<Col sm="12">
								<div className="pt-5 pb-5 text-center">
									<Spinners setLoading={() => {}} />
								</div>
							</Col>
						</Row>
					) : (
						<div>
							<Row>
								<Col sm="12">
									<div className="pt-4">
										<Row>
											<Col xs="6">
												<Row>
													<Col xs="4">
														<div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
															<span className="avatar-title rounded-circle bg-primary">
																<i className={'fas fa-sign-out-alt font-size-20'}></i>
															</span>
														</div>
													</Col>
													<Col xs="8">
														<div className="mt-2">
															<h2 className="font-size-20">{departureVesselCount}</h2>
															<p className="text-muted mb-0">{props.t('Departing')}</p>
														</div>
													</Col>
												</Row>
											</Col>
											<Col xs="6">
												<Row>
													<Col xs="4">
														<div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
															<span className="avatar-title rounded-circle bg-primary">
																<i className={'fas fa-sign-in-alt font-size-20'}></i>
															</span>
														</div>
													</Col>
													<Col xs="8">
														<div className="mt-2">
															<h2 className="font-size-20">{arrivalVesselCount}</h2>
															<p className="text-muted mb-0">{props.t('Arriving')}</p>
														</div>
													</Col>
												</Row>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
							<div className="mt-4">
								<Link to="/dashboard/arrival-departure-vessel" className="btn btn-primary  btn-sm">
									{props.t('View All Bookings')} <i className="mdi mdi-arrow-right ms-1"></i>
								</Link>
							</div>
						</div>
					)}
				</CardBody>
			</Card>
		</React.Fragment>
	);
};

export default withTranslation()(OverviewShipment);
